import { useEffect, useState } from "react";
import {
  CANAL_PANTALLA_CLIENTE,
  SILENCIO_STANDBY_MS,
  parsearMensaje,
  soportaPantallaCliente,
} from "../pantallaCliente/canal";

// Escucha los pulsos de la pestaña vendedora. Sin mensaje válido reciente la
// pantalla está en standby: al abrir, al terminar una venta y ante silencio
// prolongado se comporta igual, porque los tres casos son "no hay estado".
export default function useReceptorPantallaCliente() {
  const [mensaje, setMensaje] = useState(null);
  const [versionAjena, setVersionAjena] = useState(null);

  useEffect(() => {
    if (!soportaPantallaCliente) return undefined;
    const canal = new BroadcastChannel(CANAL_PANTALLA_CLIENTE);
    let silencio = null;

    const rearmarStandby = () => {
      clearTimeout(silencio);
      silencio = setTimeout(() => {
        setMensaje(null);
        setVersionAjena(null);
      }, SILENCIO_STANDBY_MS);
    };

    canal.onmessage = ({ data }) => {
      const resultado = parsearMensaje(data);
      if (!resultado.ok) {
        // Una versión distinta también es señal de vida: se avisa mientras
        // dure y se vuelve a standby cuando esa pestaña deja de emitir.
        if (resultado.motivo === "VERSION") {
          setMensaje(null);
          setVersionAjena({ v: resultado.version ?? null });
          rearmarStandby();
        }
        return;
      }
      setVersionAjena(null);
      setMensaje(resultado.mensaje);
      rearmarStandby();
    };
    rearmarStandby();

    return () => {
      clearTimeout(silencio);
      canal.close();
    };
  }, []);

  return {
    mensaje,
    versionIncompatible: versionAjena !== null,
    soportado: soportaPantallaCliente,
  };
}
